<template>
  <div class="donation-flow__option-label">
    <span v-if="title" class="donation-flow__option-title" :style="`color: ${disabled ? '#D1D5DB' : '#6b7280'} !important;font-size: ${fontSize} !important;font-weight: ${fontWeight} !important;`">{{
      title
    }}</span>
    <span v-if="description" class="donation-flow__option-description error--text">{{
      description
    }}</span>
  </div>
</template>
<script setup lang="ts">
defineProps({
  // translations can return TranslateResult (object) in some i18n versions; allow string or object here
  title: {
    type: [String, Object],
    default: null,
  },
  description: {
    type: [String, Object],
    default: null,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  fontSize: {
    type: String,
    default: '14px',
  },
  fontWeight: {
    type: String,
    default: '700',
  },
});
</script>
